module.exports = __webpack_public_path__ + "img/left.7167d10b.svg";